<div class="greyhounds-market">
    <span>
        @if (race.racingpost?.raceNumber) {
            <span>{{ sitecore.horseRacing.common.Race }} {{ race.racingpost?.raceNumber }} | </span>
        }
        <ms-gh-race-distance [race]="race" />
        @if (race.racingpost?.gradeCode) {
            <span> {{ race.racingpost?.gradeCode }} | </span>
        }
        @if (marketTitle.get(race.id)!) {
            <span>{{ marketTitle.get(race.id)! | uppercase }}</span>
        }
        <ms-race-view-best-odds-badge [fixture]="race" />
    </span>
</div>
